export default __webpack_public_path__ + "static/quality-control-328d45b848f9c8f5715a2b72cb42d9ff.png";